/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Divider, Stack, Typography, useTheme } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { useIsBehindFeatureFlag } from "hooks/useFeatureFlag";
import { MixSummary } from "store/api/generatedApi";
import { SummaryStat } from "src/components/common/summaryStat";

export const MixDetailsSummary = ({
  mixSummary,
  chefGroupName,
  period,
}: {
  mixSummary: MixSummary[];
  chefGroupName: string;
  period: number;
}) => {
  const { t } = useTenantTranslation();
  const theme = useTheme();
  const showInventoryDepletion = useIsBehindFeatureFlag(
    "mix_inventory_depletion"
  );
  const showChargedCost = useIsBehindFeatureFlag("show_charged_cost");

  const summary = mixSummary.find(
    (summary) =>
      summary.chef_group_name === chefGroupName && summary.period === period
  )!;

  return (
    <Stack direction="row" spacing={4} sx={{ pt: 2, pb: 1 }}>
      <SummaryStat
        label={t("heats")}
        value={summary.num_heats}
        decimalPlaces={0}
        units={null}
      />
      <SummaryStat
        label={t("yieldPercent")}
        value={summary.yield_percent}
        decimalPlaces={1}
        units="yield"
      />
      <SummaryStat
        label={t("tappedPrice")}
        value={summary.cost_per_tonne_billets_materials}
        decimalPlaces={2}
        units="specific_cost"
      />
      {showChargedCost ? (
        <SummaryStat
          label={t("chargedPrice")}
          value={summary.cost_per_tonne_charged}
          decimalPlaces={2}
          units="specific_cost"
        />
      ) : null}
      {showInventoryDepletion ? (
        <>
          <SummaryStat
            label={t("heatsUntilDepletion")}
            value={summary.heats_of_material_in_initial_inventory}
            decimalPlaces={0}
            units={null}
          />
          <Stack direction="row" gap={3}>
            <Stack>
              <Typography variant="body1Mono">
                {summary.limiting_material_in_initial_inventory ?? "N/A"}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: theme.palette.text.secondary }}
              >
                {t("limitingMaterial")}
              </Typography>
            </Stack>
            <Divider orientation="vertical" />
          </Stack>
        </>
      ) : null}
    </Stack>
  );
};
